import { useEffect } from 'react';
import type {
  CapacityGraphItemDto,
  CapacityGraphRequestParams,
} from 'src/apis/direct-fcfs/types';
import { useAxios } from 'src/hooks/use-axios';

export function useDirectFcfsCapacityGraph(
  networkPointId: string,
  params: CapacityGraphRequestParams
) {
  const capacityGraphData = useAxios(
    (
      axios,
      baseConfig,
      networkPointId: string,
      requestParams: CapacityGraphRequestParams
    ) => {
      const { capacityPoolId, ...params } = requestParams;
      return axios.request<CapacityGraphItemDto[]>({
        ...baseConfig,
        url: `${PRISMA_CONFIG.directFcfs}/network-points/${networkPointId}/capacity-pools/${capacityPoolId}/capacity-graph`,
        method: 'GET',
        params,
      });
    },
    {
      neededOnPageLoad: true,
    }
  );

  useEffect(() => {
    if (!networkPointId || !params.capacityPoolId) return;
    capacityGraphData.execute(networkPointId, params);
    // oxlint-disable-next-line exhaustive-deps
  }, [networkPointId, params]);

  if (!networkPointId || !params.capacityPoolId) return;

  return capacityGraphData;
}

export type DirectFcfsCapacityGraphRequest = ReturnType<
  typeof useDirectFcfsCapacityGraph
>;
